import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';
import GoalAndOperationalPlansForm from './GoalAndOperationalPlansForm';
import { useDisclosure } from '@hooks/useDisclosure';
import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { ICompanyValueIncreasePlansFormValues } from '../GoalAndOperationalPlansFormProvider/types';
import { useWatch } from 'react-hook-form';
import { useGoalAndOperationalPlansForm } from '../GoalAndOperationalPlansFormProvider';
import DisclosureGoalAndOperationalPlans from '@Router/GoalAndOperationalPlans/Components/Disclosure/DisclosureGoalAndOperationalPlans';

const GoalAndOperationalPlansDetail = () => {
  const { introduction, remark } =
    useWatch({
      name: 'companyValueIncreasePlans',
    }) ?? ({} as ICompanyValueIncreasePlansFormValues);
  const [
    openIntroduction,
    { open: openIntroductionDialog, close: closeIntroduction },
  ] = useDisclosure(!!introduction);

  const [openRemark, { open: openRemarkDialog, close: closeRemark }] =
    useDisclosure(!!remark);

  const { control } = useGoalAndOperationalPlansForm();

  const completedSection = useWatch({
    control,
    name: 'completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection || {};

  return (
    <Flex p={2} flexDirection={'column'} bgcolor={'white'}>
      <Flex mb={2} justifyContent={'space-between'} alignItems={'center'}>
        <Flex gap={1}>
          <Typography fontWeight={700}>
            แผนการเพิ่มมูลค่าองค์กร และเป้าหมาย
          </Typography>
          <Flex gap={0.5} alignItems={'center'}>
            <IntroductionButton
              onClick={openIntroductionDialog}
              disabled={isCompletedTh && isCompletedEn}
            />
            <RemarkButton
              onClick={openRemarkDialog}
              disabled={isCompletedTh && isCompletedEn}
            />
          </Flex>
        </Flex>
        <DisclosureGoalAndOperationalPlans />
      </Flex>

      {openIntroduction && (
        <Box mb={2}>
          <Introduction
            onDelete={closeIntroduction}
            topic="แผนการเพิ่มมูลค่าองค์กร และเป้าหมาย"
            setOpen={openIntroductionDialog}
            fieldPath="companyValueIncreasePlans.introduction"
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
        </Box>
      )}
      {openRemark && (
        <Box mb={2}>
          <Remark
            onDelete={closeRemark}
            topic="แผนการเพิ่มมูลค่าองค์กร และเป้าหมาย"
            setOpen={openRemarkDialog}
            fieldPath="companyValueIncreasePlans.remark"
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
        </Box>
      )}
      <GoalAndOperationalPlansForm />
    </Flex>
  );
};

export default GoalAndOperationalPlansDetail;
